import { QText } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../../containers/confirmation-modal';
import { ModalComponentProps } from '../../../types';

type CancelInviteConfirmationProps = ModalComponentProps & {
  removeUser: () => void;
  isDeleting: boolean;
};

export const CancelInviteConfirmation = ({ closeModal, removeUser, isDeleting }: CancelInviteConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      closeModal={closeModal}
      title={t('modals.cancelInvite.title')}
      size="lg"
      cancelLabel={t('common.no')}
      buttonProps={{
        type: 'button',
        label: t('modals.cancelInvite.yesCancelUser'),
        isDestructive: true,
        onClick: removeUser,
        isLoading: isDeleting,
      }}
    >
      <QText>{t('modals.cancelInvite.confirmMessage')}</QText>
    </ConfirmationModal>
  );
};
